<template>
  <div>
    <RateConnectStatusBar />
    <NoDataNotification v-if="hasRateConnect && !hasStatistics && statsData?.length === 0" />
    <div class="tw:my-3" v-if="hasRateConnect && hasStatistics && statsData?.length === 0">
      <div class="tw:bg-blue-200 tw:py-4 tw:px-4 tw:rounded-xl tw:text-blue-800 tw:text-sm">
        <p class="tw:font-bold">
          {{ $t('rc_booking_details_no_data_header') }}
        </p>
        <p>{{ $t('rc_booking_details_no_data_info') }}</p>
      </div>
    </div>
    <RateConnectStats
      :periodSummary="periodSummary"
      :hasStatistics="hasStatistics"
      :hasRateConnect="hasRateConnect"
      :statsData="statsData"
      :isInitialLoading="isInitialLoading"
      :partnerDistribution="partnerDistribution"
    />
  </div>
</template>
<script setup>
import RateConnectStatusBar from '@/components/homePage/performance/RateConnectStatusBar.vue'
import RateConnectStats from '@/components/homePage/performance/RateConnectStats.vue'
import NoDataNotification from './NoDataNotification.vue'

defineProps({
  periodSummary: Array,
  hasStatistics: Boolean,
  statsData: Array,
  isInitialLoading: Boolean,
  hasRateConnect: Boolean,
  partnerDistribution: Object,
})
</script>
